import { Link } from "react-router-dom";
import type { Article } from "@/types/content";

export default function TimelineSpotlight({ article }: { article: Article }) {
  return (
    <section className="border-b border-background-200 bg-secondary-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[380px_1fr] lg:items-start">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-800 px-3 py-1 text-xs font-medium text-accent-200">
              <i className="ri-drag-move-2-line text-base"></i>
              时间线对照
            </span>
            <h2 className="mt-4 font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
              同一件事，把先后顺序摆对，结论往往就变了
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              下面这条时间线来自一篇消费维权整理，我们把公开可查的节点按顺序列出，不做额外推断。
            </p>
            <Link
              to={`/article/${article.id}`}
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              阅读完整整理
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>

          <ol className="relative border-l border-secondary-700 pl-6 md:pl-8">
            {article.timeline.map((item) => (
              <li key={item.time} className="relative pb-8 last:pb-0">
                <span className="absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-secondary-950 bg-accent-400 md:-left-[39px]"></span>
                <p className="text-xs font-medium tracking-wide text-accent-300">{item.time}</p>
                <h3 className="mt-1.5 font-heading text-base font-bold text-background-50">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-background-300">{item.detail}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}